export default __webpack_public_path__ + "static/media/LSSita.a7d68237.pdf";